import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  username: string | null;
  avatarUrl: string | null;
  hasGithubToken: boolean;

  setTokens: (accessToken: string, refreshToken: string) => void;
  setUser: (username: string, avatarUrl: string | null, hasGithubToken?: boolean) => void;
  setHasGithubToken: (has: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      username: null,
      avatarUrl: null,
      hasGithubToken: false,

      setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
      setUser: (username, avatarUrl, hasGithubToken) =>
        set({ username, avatarUrl, ...(hasGithubToken !== undefined ? { hasGithubToken } : {}) }),
      setHasGithubToken: (hasGithubToken) => set({ hasGithubToken }),
      clearAuth: () =>
        set({
          accessToken: null,
          refreshToken: null,
          username: null,
          avatarUrl: null,
          hasGithubToken: false,
        }),
    }),
    {
      name: 'nopanel-auth-v2',
      version: 2,
      storage: createJSONStorage(() => sessionStorage),
      partialize: ({ accessToken, refreshToken, username, avatarUrl, hasGithubToken }) => ({
        accessToken,
        refreshToken,
        username,
        avatarUrl,
        hasGithubToken,
      }),
    },
  ),
);
